'use client'

import React from 'react'
import { LogOut } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useToast } from '@/contexts/ToastContext'
import { postSessionLogout } from '@/services/auth'
import { useLogoutData } from '@/contexts/LogoutContext'

import { Button } from '../ui/button'

const Navbar = () => {
  const router = useRouter()
  const { logoutData } = useLogoutData()
  const { showToast } = useToast()

  const handleLogout = async () => {
    try {
      if (logoutData) {
        await postSessionLogout({
          emplid: logoutData.studentId,
          ipAddress: logoutData.ipAddress,
          sessionId: logoutData.sessionId,
          loginStatus: 'N'
        })
      }

      // Redirect to configured logout URL or default to home page
      const logoutRedirectUrl = process.env.NEXT_PUBLIC_LOGOUT_REDIRECT_URL || '/'
      router.push(logoutRedirectUrl)
    } catch (error) {
      console.error('Logout error:', error)

      // Show error toast
      showToast('Logout failed. Please try again.', 'error')

      // Stay on current page by refreshing
      router.refresh()
    }
  }

  return (
    <div className='h-20 w-full shadow flex py-2 px-4 bg-white justify-between'>
      <img src='logo-uph.png' alt='Logo UPH' className='h-full' />

      <Button className='mt-4 hover:cursor-pointer' onClick={handleLogout}>
        <LogOut size='16px' /> Log Out
      </Button>
    </div>
  )
}

export default Navbar
